<template>
    <div id="app">
        <div class="container-fluid">
            <Header />
            <transition name="fade" mode="out-in">
                <LoadingScreen v-if="fetching" />
            </transition>
            <transition name="fade" mode="out-in">
                <ErrorScreen v-if="fetchingErrorCode != 0 || fetchingError != ''" />
            </transition>
            <transition name="fade" mode="out-in">
                <router-view />
            </transition>
        </div>
        <!-- <Footer /> -->
    </div>
</template>
<script>
import { 
    mapActions, 
    mapGetters, 
    // mapState 
} from 'vuex'
import LoadingScreen from '@/views/LoadingScreen.vue'
import ErrorScreen from '@/views/ErrorScreen.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
    name: 'OffenblendeQuicksale',
    components: {
        LoadingScreen, 
        ErrorScreen,
        Header,
        Footer
    },
    mounted()
    {
        this.init();
    },
    computed: {
        ...mapGetters('orders', [
            // 'job',
            // 'jobs_hash',
            'fetching', 
            'fetchingErrorCode', 
            'fetchingError', 
            // 'savingOrderSuccess', 
            'selected_category',
            'category',
            'date'
            // 'articles',
            // 'current_articles',
            // 'subCategories',
            // 'userExists',
            // 'auth',
            // 'articles',
            // 'version'
            ]),
    },
    methods: {
        ...mapActions('orders', ['setBaseData', 'resetNavigation']),
        async init() {
            // const currentVersion = await this.$store.dispatch('orders/getCurrentVersion');
            // if (currentVersion != this.version) {
            //     console.log('deletze');
            //     window.localStorage.removeItem('vuex');
            //     console.log(this.version);
            // }

            setTimeout(() => {
                this.setBaseData();
                if (this.$route.name != "BasicForm") {
                    this.resetNavigation();
                }
            }, 500);
        }
    }
}
</script>

<style lang="scss">
@import url("https://use.typekit.net/hns3ggn.css");
$font-family-base: "museo-sans", sans-serif;
$primary: #ef7d00;
$danger: #dc3545;
$success: #198754;
@import "../node_modules/bootstrap/scss/bootstrap";
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $basic-font-color;
    max-width: $app-max-width;
    margin: 0 auto;

    min-height: calc(100vh - 286px);

    .form-control[readonly] {
        opacity: 1;
        background-color: #FFFFFF;
    }

    @media (min-width: 768px) {
        max-width: $app-md-max-width;
    }
}

.copyright {
    color: #949494;

    a {
        color: #949494;
    }
}

.cd-logo {
    display: inline-block;
    vertical-align: middle;
    width: 50%;
    min-width: 250px;
    /* height: 56px; */
    height: 45px;
    background-image: url(https://offenblende.de/wp-content/themes/offenblende/img/logo.png);
    /* background-image: url(../img/logo.svg); */
    background-position: left;
    background-repeat: no-repeat;
    background-size: contain;
    -webkit-transition: all .3s ease;
    -moz-transition: all .3s ease;
    -o-transition: all .3s ease;
    -ms-transition: all .3s ease;
    transition: all .3s ease;
    height: 56px;
    top: 20px;
    height: 45px;
    -webkit-transition: all .3s ease;
    -moz-transition: all .3s ease;
    -o-transition: all .3s ease;
    -ms-transition: all .3s ease;
    transition: all .3s ease;
}

h1, h2 ,h3, h4, h5, h6 {
    font-weight: 100;
}

h2 {
    font-size: 30px;
    line-height: 40px;
    margin-bottom: 10px;
}

h3 {
    font-size: 16px;
    line-height: 26px;
    font-weight: 500;
    margin-bottom: 14px;
}

input:not([type="checkbox"], [type="radio"], [type="number"]) {
    border: 1px solid $border-color;
    width: 100%;
    padding: 12px 12px;
    margin-bottom: 15px;
    color: $dark-gray;

    .has-icon & {
        padding: 15px 12px 15px 36px !important;
    }

    .has-error & {
        border-color: red !important;
    }

    & + .icon {
        font-size: 20px;
        color: $dark-gray;
        position: absolute;
        left: 0;
        top: 0;

        position: absolute;
        left: 12px;
        height: 50px;
        top: 0;
        display: flex;
        align-items: center;
    }
}

.error-hint {
    font-size: 80%;
    transform: translateY(-12px);
    color: $danger-color;
    display: none;

    .has-error & {
        display: block;
    }
}

.help-text {
    font-size: 80%;
    transform: translateY(-12px);
    display: none;

    .focus:not(.has-error) & {
        display: block;
    }
}

.form-label {
    margin-bottom: 14px;
}

.dropdown-wrapper {
    position: relative;


    .dropdown {
        color: $dark-gray;
        width: 100%;
        border: 1px solid $border-color;
        padding: 15px 12px 15px 36px;
        margin-bottom: 15px;
        -webkit-appearance: none;
    }

    .icon {
        color: $dark-gray;
        position: absolute;
        left: 12px;
        height: 50px;
        top: 0;
        display: flex;
        align-items: center;
    }
}



.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
